import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FolderPlanogram } from 'src/app/models/folder';
import { OpenLinkedPlanogramChoice } from 'src/app/models/reference-planogram';

/**
 * Shown when opening a linked (reference) planogram. Offers three choices:
 *  1. View-only: open this linked planogram (locked) showing the reference's layout.
 *  2. Open the reference planogram in its approved state (disabled if it has none).
 *  3. Open the reference planogram in its latest state.
 * Resolves to an OpenLinkedPlanogramChoice (or null on cancel).
 */
@Component({
  selector: 'app-open-linked-planogram-modal',
  templateUrl: './open-linked-planogram-modal.component.html',
  imports: [NgIf],
})
export class OpenLinkedPlanogramModalComponent {
  @Input() planogram!: FolderPlanogram;

  constructor(public activeModal: NgbActiveModal) {}

  /** The reference has an approved state to open. */
  get hasApproved(): boolean {
    return !!this.planogram?.referenceHasApprovedState && !!this.planogram?.referenceApprovedStateId;
  }

  /** The reference has any layout at all (approved or latest) for the view-only render. */
  get hasLayout(): boolean {
    return !!(this.planogram?.referenceApprovedStateId || this.planogram?.referenceLatestStateId);
  }

  /** The reference has a latest state to open. */
  get hasLatest(): boolean {
    return !!this.planogram?.referenceLatestStateId;
  }

  choose(choice: OpenLinkedPlanogramChoice): void {
    this.activeModal.close(choice);
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}
